import React from 'react';
export const RowStore = React.createContext<{
  showMenuRowIdx: number | null;
  setShowMenuRowIdx?: (rowIdx: number, isShow: boolean) => void;
  topRowSet: Set<React.Key>;
  changeTopRowSet: (newSet: Set<React.Key>) => void;
}>({
  showMenuRowIdx: null,
  topRowSet: new Set(),
  changeTopRowSet: () => undefined,
});
